export default __webpack_public_path__ + "images/bnb_7ed5b8.svg";